module.exports = __webpack_public_path__ + "img/TZS09493.e29524df.jpeg";